interface Props {
  children?: React.ReactNode;
}

export function FilterRowCharts({ children }: Props) {
  return (
    <div className="flex flex-row flex-wrap items-center justify-center gap-x-10 gap-y-2">
      {children}
    </div>
  );
}